import { shorthands as shorts } from '@tamagui/shorthands'
import { createTamagui } from 'tamagui'

import { animations } from './theme/animations'
import { media } from './theme/media'
import { themes } from './theme/themes'
import { tokens } from './theme/tokens'
import { entrataFont, robotoFont, workSansFont } from './theme/typography'

const config = createTamagui({
  tokens,
  themes,
  animations,
  fonts: {
    body: entrataFont,
    heading: entrataFont,
    entrata: entrataFont,
    roboto: robotoFont,
    workSans: workSansFont,
  },
  defaultFont: 'entrata',
  defaultTheme: 'entrata',
  media,
  shouldAddPrefersColorThemes: false,
  themeClassNameOnRoot: false,
  shorthands: {
    ...shorts,
  },
})

export default config
export type AppConfig = typeof config

declare module 'tamagui' {
  interface TamaguiCustomConfig extends AppConfig {}
}
